//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    selectedCurrency: {
      type: String,
      default: 'czk',
    },
  },
  methods: {
    currencyChanged({ target }) {
      this.$emit('currency-changed', target.value);
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/checkout/Currency.vue